import { render, staticRenderFns } from "./CRUDTableCommonKPI.vue?vue&type=template&id=2c5ff05f&scoped=true"
import script from "./CRUDTableCommonKPI.vue?vue&type=script&lang=js"
export * from "./CRUDTableCommonKPI.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableCommonKPI.vue?vue&type=style&index=0&id=2c5ff05f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ff05f",
  null
  
)

export default component.exports